import React, { Suspense, useEffect, useState } from 'react';

const DynamicComponentLoader = ({ componentName, componentUrl, componentProps }) => {
    const [Component, setComponent] = useState(null);

    useEffect(() => {
        const loadComponent = async () => {
            const script = document.createElement('script');
            script.src = componentUrl;
            script.async = true;

            if (window["contentRender"]) {
                if (window["contentRender"]?.[componentName]) setComponent(() => window["contentRender"]?.[componentName]);
                return
            }

            script.onload = () => {
                setComponent(() => window["contentRender"]?.[componentName]);
            };

            script.onerror = (error) => {
                // console.error(`Failed to load the component from: ${componentUrl}`, error);
            };

            document.body.appendChild(script);

            return () => {
                if (!window[componentName])document.body.removeChild(script);
            };
        };

        loadComponent();

    }, [componentName, componentUrl]);

    if (!Component) {
        return null;
    }

    return <Component {...componentProps} />;
};

export default DynamicComponentLoader;